import Http from '../../common/services/Http';
import CustomFile from 'common/models/CustomFile';
import { ImportDataViewModel } from './models/ImportDataViewModel';
import { DownloadImportModelViewModel } from './models/DownloadImportModelViewModel';
import { ImportDataParseResult } from './models/ImportDataParseResult';

class ImportDataService {
    /**
     * Legacy import - used for old VEHICLES/CONTRACTS import
     * @deprecated Use parse + importAll instead
     */
    public import(model: ImportDataViewModel, attachment: CustomFile) {
        return Http.postWithFile<string>('importData', model, [attachment]);
    }

    /**
     * Legacy download - used for old VEHICLES/CONTRACTS templates
     * @deprecated Use downloadTemplate instead
     */
    public downloadLegacy(model: DownloadImportModelViewModel) {
        return Http.getWithConfig<Blob>(`importdata/download-template-legacy`, model, { responseType: 'blob' });
    }

    /**
     * Downloads the new unified import template with all 6 sheets
     * Template is generated dynamically with translations based on user's language
     */
    public downloadTemplate() {
        return Http.getWithConfig<Blob>(`importdata/download-template`, {}, { responseType: 'blob' });
    }

    /**
     * Parses the uploaded Excel file and returns structured data with validation errors
     */
    public parse(attachment: CustomFile): Promise<ImportDataParseResult> {
        return Http.postWithFile<ImportDataParseResult>('importdata/parse', {}, [attachment]);
    }

    /**
     * Re-validates edited data from the frontend
     */
    public validate(data: ImportDataParseResult): Promise<ImportDataParseResult> {
        return Http.post<ImportDataParseResult>('importdata/validate', data);
    }

    /**
     * Imports all validated data into the database
     */
    public importAll(data: ImportDataParseResult): Promise<{ success: boolean; message: string; summary: any }> {
        return Http.post<{ success: boolean; message: string; summary: any }>('importdata/import-all', data);
    }
}

export default new ImportDataService();
